export default "__VITE_ASSET__BKzIRJu6__"